/**
 * Client facades for routes/testRoutes.js — see JSDoc on each /api/test-* handler.
 */
import {
  fetchTestProgressList,
  fetchTestSubmissions,
  putTestProgress,
  deleteTestProgress,
  deleteAllTestProgress,
  postTestSubmission,
  postInterestTestDraw,
  fetchInterestTriGroupSession
} from '../utils/testApi';
import { INTEREST_SESSION_MODEL_TRI_GROUP } from '../config/interestSessionConfig';

export async function fetchTestPapers(paperType) {
  const qs = paperType ? `?paperType=${encodeURIComponent(paperType)}` : '';
  const res = await fetch(`/api/test-papers${qs}`);
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error('Failed to fetch test papers');
  }
  return Array.isArray(data) ? data : [];
}

export function fetchTestProgress(paperType, attemptId) {
  return fetchTestProgressList(paperType, attemptId);
}

export function fetchAbilitySubmissions(attemptId) {
  return fetchTestSubmissions('ability', attemptId);
}

export function fetchInterestSubmissions() {
  return fetchTestSubmissions('interest');
}

export function saveTestProgress(paperSlug, payload) {
  return putTestProgress(paperSlug, payload);
}

export function clearAllAbilityProgress() {
  return deleteAllTestProgress('ability');
}

export function clearTestProgress(paperSlug, paperType) {
  return deleteTestProgress(paperSlug, paperType);
}

export function submitTest(payload) {
  return postTestSubmission(payload);
}

export function drawInterestTestSession(options = {}) {
  return postInterestTestDraw(options);
}

export function fetchInterestTriGroupSessionState() {
  return fetchInterestTriGroupSession();
}

export function drawInterestTriGroupRound({ round, completedRounds = [] } = {}) {
  return postInterestTestDraw({
    sessionModel: INTEREST_SESSION_MODEL_TRI_GROUP,
    round,
    completedRounds
  });
}
